var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DT-onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-Step-4-Copy",
    transform: "translate(-828.000000, -662.000000)",
    className: "premiumIcon",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(595.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(229.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.48416,4.93944 L7.06056,4.51584 C6.12456,3.57924 4.60176,3.57864 3.66636,4.51464 L0.90816,7.27284 C-0.02784,8.20884 -0.02784,9.73104 0.90816,10.66704 L1.33236,11.09064 C1.78596,11.54484 2.38836,11.79444 3.02976,11.79444 C3.67116,11.79444 4.27296,11.54364 4.72596,11.09064 L6.02976,9.78864 C6.26436,9.55344 6.26436,9.17424 6.02976,8.94024 C5.79576,8.70504 5.41596,8.70504 5.18136,8.94024 L3.87756,10.24224 C3.42456,10.69644 2.63496,10.69644 2.18076,10.24224 L1.75656,9.81864 C1.28916,9.35064 1.28916,8.58924 1.75656,8.12184 L4.51476,5.36424 C4.96836,4.91004 5.75856,4.91004 6.21156,5.36424 L6.63576,5.78784 C6.87036,6.02244 7.24956,6.02244 7.48416,5.78784 C7.71876,5.55384 7.71876,5.17344 7.48416,4.93944",
    id: "Fill-2881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.09178,1.33272 L10.66758,0.90912 C10.21398,0.45552 9.61158,0.20592 8.97018,0.20592 C8.32938,0.20592 7.72698,0.45672 7.27398,0.90912 L6.08058,2.10012 C5.84658,2.33472 5.84658,2.71452 6.08058,2.94792 C6.31518,3.18312 6.69498,3.18312 6.92958,2.94792 L8.12238,1.75752 C8.57538,1.30392 9.36498,1.30332 9.81918,1.75752 L10.24338,2.18112 C10.71078,2.64912 10.71078,3.41052 10.24338,3.87852 L7.48518,6.63612 C7.03158,7.08972 6.24138,7.08972 5.78838,6.63612 C5.55438,6.40152 5.17458,6.40152 4.93998,6.63612 C4.70598,6.87072 4.70478,7.24992 4.93938,7.48392 C5.87538,8.42112 7.39818,8.42112 8.33358,7.48512 L11.09178,4.72692 C12.02778,3.79152 12.02778,2.26872 11.09178,1.33272",
    id: "Fill-2882"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link_icon.d87a9bd1b18337bbf6f9369a5cd715b0.svg";